import { Clickable, Row, ShoutoutsPage, Text } from 'components';
import { theme } from 'lib';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Shoutout = ({ data }) => {
  const { timestamp, amount } = data,
    [visible, setVisible] = useState(false),
    { t } = useTranslation(),
    { navigate } = useNavigate(),
    user = useSelector((state) => state.user),
    { shoutouts } = user,
    isAmountSingle = amount === 1;

  return (
    <React.Fragment>
      <ShoutoutsPage visible={visible} setVisible={setVisible} user={user} data={shoutouts} />

      <Clickable onClick={() => setVisible(true)}>
        <Row noFlex ht="48px" between>
          <Trans parent={Text}>
            {t(isAmountSingle ? 'notifications.aNewShoutout' : 'notifications.newShoutouts', {
              amount
            })}
          </Trans>

          <Text b2 med col={theme.GREY_60}>
            {timestamp}
          </Text>
        </Row>
      </Clickable>
    </React.Fragment>
  );
};

export default Shoutout;
